module.exports = __webpack_public_path__ + "img/home.04c9956e.png";